import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import { isBusinessObjective } from 'pricing-pages-lib/utils/businessObjectiveUtils';
import { useSelector } from 'react-redux';
import { businessObjectivesForApiNameSelector } from '../../../selectors/BusinessObjectiveSelectors';
import { Section } from '../MerchCardSharedComponents';
import BusinessObjectivesFeatures from './BusinessObjectivesFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BundleBusinessObjectives = ({
  bundleType,
  productLevel,
  commonStyles,
  apiName,
  collapseBusinessObjectives = false
}) => {
  const BO = useSelector(state => businessObjectivesForApiNameSelector(state, {
    apiName
  }));
  const features = isBusinessObjective(BO) ? BO.features && BO.features.filter(feature => !feature.hideFromLang) : [];
  const hasFeatures = features.length > 0;
  if (collapseBusinessObjectives) {
    return /*#__PURE__*/_jsx(Section, {
      className: "p-top-8",
      style: Object.assign({
        msGridRow: 8,
        gridRowStart: 8
      }, commonStyles),
      children: hasFeatures ? /*#__PURE__*/_jsx(UIAccordionItem, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.businessObjectives.seeDetails"
        }),
        renderContent: () => /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            className: "m-bottom-auto",
            message: `bundleTile.${bundleType}.${productLevel}.businessObjectives.lowerTierPlus`
          }), /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
            features: features
          })]
        })
      }, productLevel) : null
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      "data-selenium-id": "biz-objectives-1",
      className: "p-top-8",
      style: Object.assign({
        msGridRow: 8,
        gridRowStart: 8
      }, commonStyles),
      children: hasFeatures ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `bundleTile.${bundleType}.${productLevel}.businessObjectives.lowerTierPlus`
      }) : null
    }), /*#__PURE__*/_jsx(Section, {
      "data-selenium-id": "biz-objectives-2",
      style: Object.assign({
        msGridRow: 9,
        gridRowStart: 9
      }, commonStyles),
      children: hasFeatures ? /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
        features: features
      }) : null
    })]
  });
};
export default BundleBusinessObjectives;